module.exports = __webpack_public_path__ + "img/product_81.2470703.webp";